module.exports = __webpack_public_path__ + "static/media/Protect_brand_and_customer.f079ccc6.png";